import {
  AUTOMATED_CALLS_URL,
  COMM_PREFS_URL,
  EMAILS_URL,
  MAIL_URL,
  EXTRACARE_MAIL_URL,
  TEXTS_URL,
  PHARMACY_TEXTS_URL,
  EXTRACARE_TEXTS_URL,
  PHARMACY_CALLS_URL,
  PHARMACY_EMAILS_URL,
  EMAIL_ALERTS_URL,
  EXTRACARE_EMAILS_URL,
  SPECIALTY_TEXTS_URL,
  SPECIALTY_EMAIL_URL,
  CAREMARK_TEXTS_URL,
  CAREMARK_EMAIL_URL,
  CAREMARK_CALLS_URL,
} from './index';

export interface IBreadcrumb {
  text: string;
  href?: string;
  route?: string;
  linkTag?: {
    link_name?: string;
  };
}

const COMM_PREF = {
  text: 'breadcrumb.commPrefs',
  route: COMM_PREFS_URL,
};

const TEXT_PREF = {
  text: 'breadcrumb.texts',
  route: TEXTS_URL,
};

const AUTOMATED_CALLS_PREF = {
  text: 'breadcrumb.automatedCalls',
  route: AUTOMATED_CALLS_URL,
};

const EMAIL_PREF = {
  text: 'breadcrumb.emails',
  route: EMAILS_URL,
};

const MAIL_PREF = {
  text: 'breadcrumb.mail',
  route: MAIL_URL,
};

interface BreadcrumbMap {
  [route: string]: IBreadcrumb[];
}

export const BREADCRUMBS_MAP: BreadcrumbMap = {
  [TEXTS_URL]: [COMM_PREF],
  [AUTOMATED_CALLS_URL]: [COMM_PREF],
  [PHARMACY_CALLS_URL]: [COMM_PREF, AUTOMATED_CALLS_PREF],
  [PHARMACY_TEXTS_URL]: [COMM_PREF, TEXT_PREF],
  [EXTRACARE_TEXTS_URL]: [COMM_PREF, TEXT_PREF],
  [EMAILS_URL]: [COMM_PREF],
  [EMAIL_ALERTS_URL]: [COMM_PREF, EMAIL_PREF],
  [PHARMACY_EMAILS_URL]: [COMM_PREF, EMAIL_PREF],
  [EXTRACARE_EMAILS_URL]: [COMM_PREF, EMAIL_PREF],
  [MAIL_URL]: [COMM_PREF],
  [EXTRACARE_MAIL_URL]: [COMM_PREF, MAIL_PREF],
  [SPECIALTY_TEXTS_URL]: [COMM_PREF, TEXT_PREF],
  [SPECIALTY_EMAIL_URL]: [COMM_PREF, EMAIL_PREF],
  [CAREMARK_TEXTS_URL]: [COMM_PREF, TEXT_PREF],
  [CAREMARK_EMAIL_URL]: [COMM_PREF, EMAIL_PREF],
  [CAREMARK_CALLS_URL]: [COMM_PREF, AUTOMATED_CALLS_PREF],
};
